import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-select-articles',
  templateUrl: './select-articles.component.html',
  styleUrls: ['./select-articles.component.css']
})
export class SelectArticlesComponent implements OnInit {
    public setting?: Setting;

    public grid?: GridOptions;

    public searchTextButtons: FormButton[] = [
        { id: 'search', type: 'primary', icon: 'fas fa-search', onClick: () => this.retrieveChanges() }
    ];

    constructor(private datatask: DataTaskService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(2458))[0];
    }

    private loadGrid() {
        if (!!this.setting) {
            if (!this.grid) {
                this.grid = new Grid()
                    .setRememberId(this.setting?.view_id)
                    .setLoadDataFunction({
                        method: this.setting?.p2_datatask_keyno,
                        parameters: this.setting
                    })
                    .setKendoConfig({ height: '100%' })
                    .setToolbar({ wrapping: true });
            } else {
                this.grid?.gridfunc?.read();
            }
        }
    }

    public retrieveChanges() {
        this.loadGrid();
    }

    public onChanged(_: string, id: keyof Setting) {
        switch (id) {
            case 'searchtext':
                if (this.setting?.searchtext === '') this.loadGrid();
                break;
            case 'retrieve_only_selected':
                if (!!this.setting) this.loadGrid();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    searchtext: string;
    retrieve_only_selected: string;
    p2_datatask_keyno: number;
    view_id: string;
}
